import {General} from 'mattermost-redux/constants';

import {type GlobalState} from '@mattermost/types/store';

import {getAllChannelsByName} from './channels';
import {getAllGroups} from './groups';
import {getUsersByUsername} from './users';

export enum MentionType {
    USER,
    GROUP,
    CHANNEL,
}

const getMentionCriteriaMap = {
    [MentionType.USER]: getUsersByUsername,
    [MentionType.GROUP]: getAllGroups,
    [MentionType.CHANNEL]: getAllChannelsByName,
};

export const getMentionsInMessage = (message: string, state: GlobalState, criteria = MentionType.USER) => {
    const symbol = criteria === MentionType.CHANNEL ? '~' : '@';
    const mentions = new Set<string>();

    if (!message.includes(symbol)) {
        return mentions;
    }
    const criteriaMap = getMentionCriteriaMap[criteria](state);

    const pattern = new RegExp(`\\B${symbol}(([a-z0-9_.-]*[a-z0-9_])[.-]*)`, 'gi');

    let match;
    while ((match = pattern.exec(message)) !== null) {
        // match[1] is the matched mention including trailing punctuation
        // match[2] is the matched mention without trailing punctuation
        if (General.SPECIAL_MENTIONS.indexOf(match[2]) !== -1) {
            continue;
        }

        if (criteriaMap[match[1]] || criteriaMap[match[2]]) {
            // We have the user, go to the next match
            continue;
        }

        // If there's no trailing punctuation, this will only add 1 item to the set
        if (match[1]) {
            mentions.add(match[1]);
        }
        if (match[2]) {
            mentions.add(match[2]);
        }
    }

    return mentions;
};
